import React from "react";

const PrijemnicaZaStampu = ({ podaci }) => {
  const {
    BrojPrijemnice = "",
    BrojOtpremnice = "",
    Datum = "",
    Dobavljac = "",
    Firma = "",
    Registracija = "",
    Napomena = "",
    Stavke = [],
  } = podaci ?? {};

  const nbspIfEmpty = (v) =>
    v === 0 ? "0" : v === null || v === undefined || v === "" ? "\u00A0" : v;

  const prviMagacin =
    Array.isArray(Stavke) && Stavke.length > 0
      ? Stavke[0]?.Magacin || ""
      : "";

  const printStyles = `
    * { box-sizing: border-box; }
    html, body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      color: #000;
      font-size: 11pt;
      background: #fff;
    }

    @page {
      size: A4 portrait;
      margin: 16mm 14mm;
    }

    #prijemnica-page {
      margin:10% 1px 0 1px;
      width: 100%;
    }

    .page-title {
      text-align: center;
      font-size: 22pt;
      font-weight: 700;
      margin: 0 0 14px 0;
    }

    .top-number {
      text-align: center;
      font-size: 13pt;
      font-weight: 700;
      margin-bottom: 18px;
    }

    .meta-grid {
      display: grid;
      grid-template-columns: 180px 1fr;
      gap: 0;
      border: 1px solid #000;
      border-bottom: none;
      margin-bottom: 18px;
    }

    .meta-label,
    .meta-value {
      min-height: 34px;
      padding: 8px 10px;
      border-bottom: 1px solid #000;
    }

    .meta-label {
      font-weight: 700;
      border-right: 1px solid #000;
      background: #f2f2f2;
    }

    .meta-value {
      word-break: break-word;
    }

    .section-gap {
      height: 10px;
    }

    .items-title {
      font-size: 13pt;
      font-weight: 700;
      margin: 0 0 8px 0;
    }

    table.items-table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      font-size: 10.5pt;
    }

    .items-table th,
    .items-table td {
      padding: 8px 6px;
      vertical-align: middle;
      word-break: break-word;
    }

    .items-table th {
      background: #e9e9e9;
      font-weight: 700;
      text-align: center;
    }

    .col-rb { width: 7%; text-align: center; }
    .col-sifra { width: 14%; text-align: center; }
    .col-artikal { width: 31%; }
    .col-kolicina { width: 14%; text-align: right; }
    .col-jm { width: 12%; text-align: center; }
    .col-magacin { width: 22%; }

    .text-center { text-align: center; }
    .text-right { text-align: right; }

    .note-box {
      margin-top: 18px;
      border: 1px solid #000;
    }

    .note-title {
      padding: 8px 10px;
      font-weight: 700;
      background: #f2f2f2;
      border-bottom: 1px solid #000;
    }

    .note-value {
      min-height: 70px;
      padding: 10px;
      white-space: pre-wrap;
      word-break: break-word;
    }

    .signature-wrap {
      margin-top: 34px;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
    }

    .signature-box {
      text-align: center;
    }

    .signature-line {
      margin-top: 45px;
      border-top: 1px solid #000;
      padding-top: 6px;
      font-size: 10pt;
    }
    
    .fontSizeTd {
    font-size: 18px;
    font-weight: 300;
    padding-top: 1% !important;
    padding-bottom: 1% !important;
    }

    .screen-only {
      margin-bottom: 12px;
    }

    @media print {
      .screen-only { display: none !important; }
      * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }
  `;

  return (
    <div id="prijemnica-page">
      <style>{printStyles}</style>

        <div className="page-title">PRIJEMNICA</div>

      <div className="meta-grid">
        <div className="meta-label">Broj prijemnice</div>
        <div className="meta-value">{nbspIfEmpty(BrojPrijemnice)}</div>

        <div className="meta-label">Datum</div>
        <div className="meta-value">{nbspIfEmpty(Datum)}</div>

        <div className="meta-label">Dobavljač</div>
        <div className="meta-value">{nbspIfEmpty(Dobavljac)}</div>

        <div className="meta-label">Firma</div>
        <div className="meta-value">{nbspIfEmpty(Firma)}</div>

        <div className="meta-label">Registracija</div>
        <div className="meta-value">{nbspIfEmpty(Registracija)}</div>
      </div>

      <div className="items-title">Stavke:</div>

      <table className="items-table">
        <thead>
          <tr>
            <th className="col-rb" style={{border: '1px solid #000'}}>RB</th>
            <th className="col-sifra" style={{border: '1px solid #000'}}>Šifra artikla</th>
            <th className="col-artikal" style={{border: '1px solid #000'}}>Artikal</th>
            <th className="col-kolicina" style={{border: '1px solid #000'}}>Količina</th>
            <th className="col-jm" style={{border: '1px solid #000'}}>JM</th>
            <th className="col-magacin" style={{border: '1px solid #000'}}>Magacin</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(Stavke) && Stavke.length > 0 ? (
            Stavke.map((stavka, index) => (
              <tr key={index}>
                <td className="col-rb text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.RB ?? index + 1)}
                </td>
                <td className="col-sifra text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.["Šifra artikla"])}
                </td>
                <td className="col-artikal text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.Artikal)}
                </td>
                <td className="col-kolicina text-center fontSizeTd">
                  {stavka?.Količina ?? "\u00A0"}
                </td>
                <td className="col-jm text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.JM)}
                </td>
                <td className="col-magacin text-center fontSizeTd">
                  {nbspIfEmpty(stavka?.Magacin)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={6} className="text-center" style={{ height: "42px" }}>
                Nema stavki
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <div style={{marginTop: '1%', minWidth:'100%', borderTop: '1px black dotted'}}></div>
      <div className="note-box">
        <div className="note-title">Napomena</div>
        <div className="note-value">{nbspIfEmpty(Napomena)}</div>
      </div>

      <div className="signature-wrap">
        <div className="signature-box">
          <div className="signature-line">Primio</div>
        </div>
      </div>
    </div>
  );
};

export default PrijemnicaZaStampu;